import About from "./About";
import Banner from "./Banner";
import FeatureProducts from "./FeatureProducts";
import Header from "./Header";

const Home = () => {
	return (
		<>
			<Header />
			<About />
			<Banner />
			<FeatureProducts />
		</>
	);
};
export default Home;
